import { Package, PackageHost } from '../../Container';

export class CallPackage implements Package {

    public install = (host: PackageHost) => {
        // The CallLayer component is directly used in Editor.tsx
        // No need to register it explicitly
    };
}
